// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"402":"b0f292bc","413":"ba98d718","770":"a7888987"}[chunkId] + ".chunk.js";
};